export default [
  {
    path: '/login',
    component: () => import('../layouts/auth/AuthLayout.vue'),
    children: [
      {
        path: '',
        name: 'login',
        meta: {
          title: 'Login',
        },
        component: () => import('../views/auth/SignIn.vue'),
      },
      {
        path: 'sso',
        name: 'sso-dash',
        meta: {
          title: 'SSO Dashboard',
        },
        component: () => import('../views/admin/SSODashPage.vue'),
      },
    ],
  },
  {
    path: '/forgot-password',
    component: () => import('../layouts/auth/AuthLayout.vue'),
    children: [
      {
        path: '',
        name: 'forgot-password',
        meta: {
          title: 'Forgot Password',
        },
        component: () => import('../views/auth/ForgotPassword.vue'),
      },
    ],
  },
  {
    path: '/reset-password',
    component: () => import('../layouts/auth/AuthLayout.vue'),
    children: [
      {
        path: '',
        name: 'reset-password',
        meta: {
          title: 'Reset Password',
        },
        component: () => import('../views/auth/ResetPassword.vue'),
      },
    ],
  },
]
